import { Spin } from "antd";
import React, { lazy } from "react";
import { useState } from "react";
import {
  Accordion,
  Col,
  Nav,
  OverlayTrigger,
  Row,
  Tab,
  Tooltip,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EmailSettings from "./EmailSettings";
import { Field, Form, FormikProvider, useFormik } from "formik";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { post } from "../../../helpers/api_helper";
import {
  POST_EInvoiceConfigurationSave,
  POST_GetApplicationSetupByCompanyID,
  POST_NotificationConfigurationInsert,
  POST_NotificationConfigurationUpdate,
  POST_SentenceConfigurationInsert,
  POST_SentenceConfigurationUpdate,
  POST_WhatsAppConfigurationSetupSave,
} from "../../../helpers/url_helper";
import { useEffect } from "react";
import swal from "sweetalert";
import { errorMessage, successMessage } from "../CommonFunctions";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomInput from "../../../CustomControls/CustomInput";
import * as Yup from "yup";

const ApplicationSetup = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [emailConfigurationList, setEmailConfigurationList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const yesNoOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const formikNotification = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitNotification(values, formikHelpers),
    initialValues: {
      NotificationConfigurationIDEncrypt: "",
      Email: false,
      SMS: false,
      NotificationBar: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { NotificationConfigurationIDEncrypt },
  } = formikNotification;

  const handleValidSubmitNotification = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,

      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      NotificationConfigurationIDEncrypt
        ? POST_NotificationConfigurationUpdate
        : POST_NotificationConfigurationInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          formikNotification.setFieldValue(
            "NotificationConfigurationIDEncrypt",
            response?.EncryptID
          );
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
        // setTimeout(() => {
        //   navigate("/dashboard");
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const formikSentence = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSentence(values, formikHelpers),
    initialValues: {
      SentenceConfigurationIDEncrypt: "",
      NABLSentence: "",
      RewiseSentence: "",
      PreviousPaperIgnoreSentence: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { SentenceConfigurationIDEncrypt },
  } = formikSentence;

  const handleValidSubmitSentence = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      SentenceConfigurationIDEncrypt
        ? POST_SentenceConfigurationUpdate
        : POST_SentenceConfigurationInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          formikSentence.setFieldValue(
            "SentenceConfigurationIDEncrypt",
            response?.EncryptID
          );
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
        // setTimeout(() => {
        //   navigate("/dashboard");
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaEInvoice = Yup.object().shape({
    SandboxPublicKey: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Public Key is required field");
        return schema;
      }
    ),
    SandboxUserName: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Username is required field");
        return schema;
      }
    ),
    SandboxPassword: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Password is required field");
        return schema;
      }
    ),
    SandboxClientID: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Client ID is required field");
        return schema;
      }
    ),
    SandboxClientSecret: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string()
            .trim()
            .required("Client Secret is required field");
        return schema;
      }
    ),
    SandboxGSTIN: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("GSTIN is required field");
        return schema;
      }
    ),
    ProductionPublicKey: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Public Key is required field");
        return schema;
      }
    ),
    ProductionUserName: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Username is required field");
        return schema;
      }
    ),
    ProductionPassword: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Password is required field");
        return schema;
      }
    ),
    ProductionClientID: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string().trim().required("Client ID is required field");
        return schema;
      }
    ),
    ProductionClientSecret: Yup.string().when(
      "EInvoiceApplicable",
      ([EInvoiceApplicable], schema) => {
        if (EInvoiceApplicable == true)
          return Yup.string()
            .trim()
            .required("Client Secret is required field");
        return schema;
      }
    ),
  });

  const formikEInvoice = useFormik({
    validationSchema: validationSchemaEInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitEInvoice(values, formikHelpers),
    initialValues: {
      EInvoiceConfigurationIDEncrypt: "",
      EInvoiceApplicable: false,
      DefaultEnvironmentType: 1,
      SandboxPublicKey: "",
      SandboxUserName: "",
      SandboxPassword: "",
      SandboxClientID: "",
      SandboxClientSecret: "",
      SandboxGSTIN: "",
      ProductionPublicKey: "",
      ProductionUserName: "",
      ProductionPassword: "",
      ProductionClientID: "",
      ProductionClientSecret: "",
      ProductionGSTIN: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { EInvoiceConfigurationIDEncrypt, EInvoiceApplicable },
  } = formikEInvoice;

  const handleValidSubmitEInvoice = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_EInvoiceConfigurationSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          var obj = JSON.parse(localStorage.getItem("userDetails"));
          obj.EInvoiceApplicable = values?.EInvoiceApplicable;
          localStorage.setItem("userDetails", JSON.stringify(obj));

          successMessage(response?.Message);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
        // setTimeout(() => {
        //   navigate("/dashboard");
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaWhatsApp = Yup.object().shape({
    WhatsAppBusinessPhoneNumberID: Yup.string()
      .trim()
      .required("WhatsApp Business Phone Number ID is required field"),
    // WhatsAppBusinessAccountID: Yup.string()
    //   .trim()
    //   .required("WhatsApp Business Account ID is required field"),
    // WhatsAppBusinessID: Yup.string()
    //   .trim()
    //   .required("WhatsApp Business ID is required field"),
    AccessToken: Yup.string().trim().required("AccessToken is required field"),
    WhatsAppVersion: Yup.string()
      .trim()
      .required("WhatsApp Version is required field"),
    // AppName: Yup.string().trim().required("App Name is required field"),
  });

  const formikWhatsApp = useFormik({
    validationSchema: validationSchemaWhatsApp,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitWhatsApp(values, formikHelpers),
    initialValues: {
      WhatsAppConfigurationSetupIDEncrypt: "",
      WhatsAppBusinessPhoneNumberID: "",
      WhatsAppBusinessAccountID: "",
      WhatsAppBusinessID: "",
      AccessToken: "",
      WhatsAppVersion: "",
      AppName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { WhatsAppConfigurationIDEncrypt },
  } = formikEInvoice;

  const handleValidSubmitWhatsApp = (values) => {
    setIsLoading(true);

    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_WhatsAppConfigurationSetupSave, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
        // setTimeout(() => {
        //   navigate("/dashboard");
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getApplicationSetupDetails = () => {
    setIsLoading(true);
    post(POST_GetApplicationSetupByCompanyID, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmailConfigurationList(response?.EmailConfigurationList);
          formikNotification.setValues({
            ...response?.NotificationConfiguration,
          });
          formikSentence.setValues({
            ...response?.SentenceConfiguration,
          });
          formikEInvoice.setValues({
            ...response?.EInvoiceConfiguration,
            DefaultEnvironmentType:
              response?.EInvoiceConfiguration?.DefaultEnvironmentType > 0
                ? response?.EInvoiceConfiguration?.DefaultEnvironmentType
                : 1,
          });
          formikWhatsApp.setValues({
            ...response?.WhatsAppConfigurationSetup,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getApplicationSetupDetails();
  }, []);

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Application Setup</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <div className="default-tab">
              <Tab.Container
                defaultActiveKey={
                  AuthUser?.Permissions?.Email == 1 ? "email" : "sentence"
                }
              >
                <Nav as="ul" className="nav-tabs">
                  {AuthUser?.Permissions?.Email == 1 ? (
                    <Nav.Item as="li" key={0}>
                      <Nav.Link eventKey={"email"}>
                        <i className="la la-envelope me-2" />
                        Email
                      </Nav.Link>
                    </Nav.Item>
                  ) : (
                    ""
                  )}
                  {/* <Nav.Item as="li" key={1}>
                    <Nav.Link eventKey={"notification"}>
                      <i className="la la-bell me-2" />
                      Notification
                    </Nav.Link>
                  </Nav.Item> */}
                  <Nav.Item as="li" key={2}>
                    <Nav.Link eventKey={"sentence"}>
                      <i className="la la-comment me-2" />
                      Sentence
                    </Nav.Link>
                  </Nav.Item>
                  {AuthUser?.Permissions?.Account == 1 && (
                    <Nav.Item as="li" key={3}>
                      <Nav.Link eventKey={"eInvoice"}>
                        <i className="la la-file-invoice me-2" />
                        E-Invoice
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  {AuthUser?.Permissions?.Whatsup == 1 && (
                    <Nav.Item as="li" key={4}>
                      <Nav.Link eventKey={"whatsApp"}>
                        <i className="fab la-whatsapp me-2" />
                        WhatsApp
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
                <Tab.Content className="pt-2">
                  {AuthUser?.Permissions?.Email == 1 ? (
                    <Tab.Pane eventKey={"email"} key={0}>
                      <Accordion
                        className="accordion accordion-primary"
                        defaultActiveKey="4"
                      >
                        <Accordion.Item
                          className="accordion-item"
                          key={4}
                          eventKey={"4"}
                        >
                          <Accordion.Header className="accordion-header rounded-lg">
                            Broadcast Message Mail Settings
                          </Accordion.Header>
                          <Accordion.Collapse eventKey={"4"}>
                            <div className="accordion-body">
                              <EmailSettings
                                EmailType={5}
                                setIsLoading={setIsLoading}
                                data={
                                  emailConfigurationList?.filter(
                                    (x) => x.EmailType == 5
                                  )[0]
                                }
                              />
                            </div>
                          </Accordion.Collapse>
                        </Accordion.Item>

                        <Accordion.Item
                          className="accordion-item"
                          key={0}
                          eventKey={"0"}
                        >
                          <Accordion.Header className="accordion-header rounded-lg">
                            Inward Mail Settings
                          </Accordion.Header>
                          <Accordion.Collapse eventKey={"0"}>
                            <div className="accordion-body">
                              <EmailSettings
                                EmailType={1}
                                setIsLoading={setIsLoading}
                                data={
                                  emailConfigurationList?.filter(
                                    (x) => x.EmailType == 1
                                  )[0]
                                }
                              />
                            </div>
                          </Accordion.Collapse>
                        </Accordion.Item>
                        {AuthUser?.Permissions?.DispatchReport == 1 && (
                          <Accordion.Item
                            className="accordion-item"
                            key={1}
                            eventKey={"1"}
                          >
                            <Accordion.Header className="accordion-header rounded-lg">
                              Dispatch Report Mail Settings
                            </Accordion.Header>
                            <Accordion.Collapse eventKey={"1"}>
                              <div className="accordion-body">
                                <EmailSettings
                                  EmailType={2}
                                  setIsLoading={setIsLoading}
                                  data={
                                    emailConfigurationList?.filter(
                                      (x) => x.EmailType == 2
                                    )[0]
                                  }
                                />
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        )}
                        {AuthUser?.Permissions?.UploadScanCopy == 1 ? (
                          <Accordion.Item
                            className="accordion-item"
                            key={2}
                            eventKey={"2"}
                          >
                            <Accordion.Header className="accordion-header rounded-lg">
                              Upload Scan Copy Mail Settings
                            </Accordion.Header>
                            <Accordion.Collapse eventKey={"2"}>
                              <div className="accordion-body">
                                <EmailSettings
                                  EmailType={3}
                                  setIsLoading={setIsLoading}
                                  data={
                                    emailConfigurationList?.filter(
                                      (x) => x.EmailType == 3
                                    )[0]
                                  }
                                />
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        ) : (
                          ""
                        )}
                        {AuthUser?.Permissions?.Account == 1 ? (
                          <Accordion.Item
                            className="accordion-item"
                            key={3}
                            eventKey={"3"}
                          >
                            <Accordion.Header className="accordion-header rounded-lg">
                              Invoice Mail Settings
                            </Accordion.Header>
                            <Accordion.Collapse eventKey={"3"}>
                              <div className="accordion-body">
                                <EmailSettings
                                  EmailType={4}
                                  setIsLoading={setIsLoading}
                                  data={
                                    emailConfigurationList?.filter(
                                      (x) => x.EmailType == 4
                                    )[0]
                                  }
                                />
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        ) : (
                          ""
                        )}
                        {AuthUser?.Permissions?.MachineMaintenance == 1 ? (
                          <Accordion.Item
                            className="accordion-item"
                            key={5}
                            eventKey={"5"}
                          >
                            <Accordion.Header className="accordion-header rounded-lg">
                              Machine Calibration Mail Settings
                            </Accordion.Header>
                            <Accordion.Collapse eventKey={"5"}>
                              <div className="accordion-body">
                                <EmailSettings
                                  EmailType={6}
                                  setIsLoading={setIsLoading}
                                  data={
                                    emailConfigurationList?.filter(
                                      (x) => x.EmailType == 6
                                    )[0]
                                  }
                                />
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        ) : (
                          ""
                        )}
                      </Accordion>
                    </Tab.Pane>
                  ) : (
                    ""
                  )}
                  <Tab.Pane eventKey={"notification"} key={1}>
                    <FormikProvider value={formikNotification}>
                      <Form onSubmit={formikNotification.handleSubmit}>
                        <Row>
                          <Col lg={3}>
                            <Field
                              label="Email"
                              name="Email"
                              placeholder={"Select"}
                              options={yesNoOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="SMS"
                              name="SMS"
                              placeholder={"Select"}
                              options={yesNoOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="NotificationBar"
                              name="NotificationBar"
                              placeholder={"Select"}
                              options={yesNoOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                        </Row>
                        <hr className="mt-1 mb-2"></hr>
                        <button
                          type="submit"
                          // className="btn btn-primary"
                          className="btn btn-primary btn-sm me-2"
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Submit
                        </button>
                        <button
                          type="button"
                          // className="btn btn-danger light"
                          className="btn btn-danger btn-sm me-2"
                          onClick={(e) => {
                            navigate("/dashboard");
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </Form>
                    </FormikProvider>
                  </Tab.Pane>
                  <Tab.Pane eventKey={"sentence"} key={2}>
                    <FormikProvider value={formikSentence}>
                      <Form onSubmit={formikSentence.handleSubmit}>
                        <Row>
                          <Col lg={6}>
                            <Field
                              label="NABL Sentence"
                              name="NABLSentence"
                              placeholder={"Enter NABL Sentence"}
                              component={CustomTextArea}
                              rows={3}
                              maxLength={1000}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Revision Sentence"
                              name="RewiseSentence"
                              placeholder={"Enter Revision Sentence"}
                              component={CustomTextArea}
                              rows={3}
                              maxLength={500}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Previous Paper Ignore Sentence"
                              name="PreviousPaperIgnoreSentence"
                              placeholder={
                                "Enter Previous Paper Ignore Sentence"
                              }
                              component={CustomTextArea}
                              rows={3}
                              maxLength={500}
                            />
                          </Col>
                        </Row>
                        <hr className="mt-1 mb-2"></hr>
                        <button
                          type="submit"
                          // className="btn btn-primary"
                          className="btn btn-primary btn-sm me-2"
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Submit
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          // className="btn btn-danger light"
                          className="btn btn-danger btn-sm me-2"
                          onClick={(e) => {
                            navigate("/dashboard");
                          }}
                        >
                          <i className="fa fa-cancel"></i> Cancel
                        </button>
                      </Form>
                    </FormikProvider>
                  </Tab.Pane>
                  {AuthUser?.Permissions?.Account == 1 && (
                    <Tab.Pane eventKey={"eInvoice"} key={3}>
                      <FormikProvider value={formikEInvoice}>
                        <Form onSubmit={formikEInvoice.handleSubmit}>
                          <Row>
                            <Col lg={3}>
                              <Field
                                label="E-Invoice Applicable"
                                name="EInvoiceApplicable"
                                placeholder={"Select"}
                                options={yesNoOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                            {EInvoiceApplicable == true && (
                              <>
                                <Col lg={9}>
                                  <label>
                                    E-Invoice Default Environment &nbsp;
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      responsive={true}
                                      overlay={
                                        <Tooltip className="toltip-popover">
                                          <strong className="p-1">
                                            {" "}
                                            E-Invoice environment : Sandbox
                                            (Testing mode), Production (Live
                                            mode)
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                    &nbsp;:
                                  </label>
                                  <div>
                                    <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        id="customRadioEnvironmentType1"
                                        name="DefaultEnvironmentType"
                                        title="Sandbox"
                                        style={{ cursor: "pointer" }}
                                        checked={
                                          formikEInvoice.values
                                            .DefaultEnvironmentType == 1
                                        }
                                        onChange={() => {
                                          formikEInvoice.setFieldValue(
                                            "DefaultEnvironmentType",
                                            1
                                          );
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customRadioEnvironmentType1"
                                      >
                                        Sandbox
                                      </label>
                                    </div>
                                    <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        id="customRadioEnvironmentType2"
                                        name="DefaultEnvironmentType"
                                        title="Production"
                                        style={{ cursor: "pointer" }}
                                        checked={
                                          formikEInvoice.values
                                            .DefaultEnvironmentType == 2
                                        }
                                        onChange={() => {
                                          formikEInvoice.setFieldValue(
                                            "DefaultEnvironmentType",
                                            2
                                          );
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="customRadioEnvironmentType2"
                                      >
                                        Production
                                      </label>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <div
                                    className="card mb-2"
                                    style={{ height: "auto" }}
                                  >
                                    <div className="card-header p-2 ps-3 pb-0">
                                      <label className="text-primary">
                                        Sandbox Configuration
                                      </label>
                                    </div>
                                    <div className="card-body fs-14 pt-1 pb-2">
                                      <Row>
                                        <Col lg={6}>
                                          <Row>
                                            <Col lg={12}>
                                              <Field
                                                label="Client ID"
                                                name="SandboxClientID"
                                                placeholder={"Enter Client ID"}
                                                component={CustomInput}
                                                maxLength={250}
                                                required
                                              />
                                            </Col>
                                            <Col lg={12}>
                                              <Field
                                                label="Client Secret"
                                                name="SandboxClientSecret"
                                                placeholder={
                                                  "Enter Client Secret"
                                                }
                                                component={CustomInput}
                                                maxLength={250}
                                                required
                                              />
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col lg={6}>
                                          <Field
                                            label="Public Key"
                                            name="SandboxPublicKey"
                                            placeholder={"Enter Public Key"}
                                            component={CustomTextArea}
                                            rows={5}
                                            maxLength={1000}
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Field
                                            label="Username"
                                            name="SandboxUserName"
                                            placeholder={"Enter Username"}
                                            component={CustomInput}
                                            maxLength={100}
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Field
                                            label="Password"
                                            type="password"
                                            name="SandboxPassword"
                                            placeholder={"Enter Password"}
                                            component={CustomInput}
                                            maxLength={250}
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Field
                                            label="GSTIN"
                                            name="SandboxGSTIN"
                                            placeholder={"Enter GSTIN"}
                                            component={CustomInput}
                                            maxLength={100}
                                            required
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <div
                                    className="card mb-2"
                                    style={{ height: "auto" }}
                                  >
                                    <div className="card-header p-2 ps-3 pb-0">
                                      <label className="text-primary">
                                        Production Configuration
                                      </label>
                                    </div>
                                    <div className="card-body fs-14 pt-1 pb-2">
                                      <Row>
                                        <Col lg={6}>
                                          <Row>
                                            <Col lg={12}>
                                              <Field
                                                label="Client ID"
                                                name="ProductionClientID"
                                                placeholder={"Enter Client ID"}
                                                component={CustomInput}
                                                maxLength={250}
                                                required
                                              />
                                            </Col>
                                            <Col lg={12}>
                                              <Field
                                                label="Client Secret"
                                                name="ProductionClientSecret"
                                                placeholder={
                                                  "Enter Client Secret"
                                                }
                                                component={CustomInput}
                                                maxLength={250}
                                                required
                                              />
                                            </Col>
                                          </Row>
                                        </Col>

                                        <Col lg={6}>
                                          <Field
                                            label="Public Key"
                                            name="ProductionPublicKey"
                                            placeholder={"Enter Public Key"}
                                            component={CustomTextArea}
                                            rows={5}
                                            maxLength={1000}
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Field
                                            label="Username"
                                            name="ProductionUserName"
                                            placeholder={"Enter Username"}
                                            component={CustomInput}
                                            maxLength={100}
                                            required
                                          />
                                        </Col>
                                        <Col lg={3}>
                                          <Field
                                            label="Password"
                                            type="password"
                                            name="ProductionPassword"
                                            placeholder={"Enter Password"}
                                            component={CustomInput}
                                            maxLength={250}
                                            required
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </>
                            )}
                          </Row>
                          <hr className="mt-1 mb-2"></hr>
                          <button
                            type="submit"
                            // className="btn btn-primary"
                            className="btn btn-primary btn-sm me-2"
                          >
                            <i className="fa-solid fa-floppy-disk"></i> Submit
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            // className="btn btn-danger light"
                            className="btn btn-danger btn-sm me-2"
                            onClick={(e) => {
                              navigate("/dashboard");
                            }}
                          >
                            <i className="fa fa-cancel"></i> Cancel
                          </button>
                        </Form>
                      </FormikProvider>
                    </Tab.Pane>
                  )}
                  {AuthUser?.Permissions?.Whatsup == 1 && (
                    <Tab.Pane eventKey={"whatsApp"} key={4}>
                      <FormikProvider value={formikWhatsApp}>
                        <Form onSubmit={formikWhatsApp.handleSubmit}>
                          <Row>
                            <Col lg={6}>
                              <Row>
                                <Col lg={6}>
                                  <Field
                                    label="WhatsApp Business Phone Number ID"
                                    name="WhatsAppBusinessPhoneNumberID"
                                    placeholder={
                                      "Enter WhatsApp Business Phone Number ID"
                                    }
                                    component={CustomInput}
                                    maxLength={1000}
                                    required
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="WhatsApp Version"
                                    name="WhatsAppVersion"
                                    placeholder={"Enter WhatsApp Version"}
                                    component={CustomInput}
                                    maxLength={500}
                                    required
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="WhatsApp Business Account ID"
                                    name="WhatsAppBusinessAccountID"
                                    placeholder={
                                      "Enter WhatsApp Business Account ID"
                                    }
                                    component={CustomInput}
                                    maxLength={1000}
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="WhatsApp Business ID"
                                    name="WhatsAppBusinessID"
                                    placeholder={"Enter WhatsApp Business ID"}
                                    component={CustomInput}
                                    maxLength={1000}
                                  />
                                </Col>

                                <Col lg={6}>
                                  <Field
                                    label="App Name"
                                    name="AppName"
                                    placeholder={"Enter App Name"}
                                    component={CustomInput}
                                    maxLength={500}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={6}>
                              <Field
                                label="Access Token"
                                name="AccessToken"
                                placeholder={"Enter Access Token"}
                                component={CustomTextArea}
                                rows={4}
                                maxLength={1000}
                                required
                              />
                            </Col>
                          </Row>
                          <hr className="mt-1 mb-2"></hr>
                          <button
                            type="submit"
                            // className="btn btn-primary"
                            className="btn btn-primary btn-sm me-2"
                          >
                            <i className="fa-solid fa-floppy-disk"></i> Submit
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            // className="btn btn-danger light"
                            className="btn btn-danger btn-sm me-2"
                            onClick={(e) => {
                              navigate("/dashboard");
                            }}
                          >
                            <i className="fa fa-cancel"></i> Cancel
                          </button>
                        </Form>
                      </FormikProvider>
                    </Tab.Pane>
                  )}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default ApplicationSetup;
